export const getWidthOfTheElementById = (elementId) => {
    return document.getElementById(elementId).offsetWidth;
};

export const handleOnChange = (currentIndex, data, panelPerView, initial) => {
    let hidePrevArrow = initial || currentIndex === 0;
    let hideNextArrow = false;

    if (
        initial
            ? Math.round(panelPerView) >= data.length
            : Math.round(currentIndex + panelPerView) >= data.length
    ) {
        hideNextArrow = true;
    }
    return { hidePrevArrow, hideNextArrow };
};
